import React, { Component } from 'react';
import ReactImageFallback from "react-image-fallback";
import { IMGIX_PATH } from '../../constants';

import $ from "jquery";
import * as galleryReducers from "../../reducers/gallery";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";
import AudioItem from "../includes/Slider/AudioItem";

class GraphicItem extends Component {

    constructor(props) {
        super(props);
         this.state = {
            visible: false,
            imageId: '',
            showModal : false,
            modalOptions : { showHeader : false, showFooter : false , title : '', id : "galleryModal", content: '' },
             selected_class : ' active',

        };

        this.mToggle = this.mToggle.bind(this);
        this.initiateSlider = this.initiateSlider.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.closeAudio = this.closeAudio.bind(this);
    }

    mToggle() {
        this.setState({ showModal : true, modalOptions:{showModal: this.state.showModal} });
       // this.state.modalOptions.showModal = this.state.showModal;
    }

    initiateSlider(index) {
        $(".carousel-item").removeClass('active');
        $(".carousel-item:eq("+this.props.galIndex+")").addClass('active');
        let data = {"index" :  this.props.galIndex};

        console.log("this.props.galIndex"+this.props.galIndex);
        this.props.setItemId(data);
        if(this.props.galleryInfo.gal_type === 'MY_UPLOADS') {
            let new_class = this.state.wrap_class+ ' '+ this.state.selected_class;
            this.setState({wrap_class : new_class});
        }
        else if(this.props.galleryInfo.gal_type === 'VIDEO') {

            /*var sounds = document.getElementsByTagName('video');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }*/

            $(".video-react-video")[index].play();
        }

    }

    playAudio(index) {

        var element = document.getElementById("audio"+index);

        if( element.parentNode.classList.contains("player-static")) {

            var sounds = document.getElementsByTagName('audio');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {console.log(i+"=============="+index);
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }

            this.setState({wrap_class : 'ind-galler-list sl-item '});

            var audio = document.getElementById("audio"+index);
            audio.play();

        }

    }

    playVideo(index) {

        var element = document.getElementById("audio"+index);

        if( element.parentNode.classList.contains("player-static")) {

            var sounds = document.getElementsByTagName('audio');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }

            this.setState({wrap_class : 'ind-galler-list sl-item '});

            var audio = document.getElementById("audio"+index);
            audio.play();

        }

    }

    closeAudio(e,index) {
        e.preventDefault();
        e.stopPropagation();
        var sound = document.getElementById("audio"+index);
        sound.pause();
        sound.parentNode.classList.add("player-static");
    }


    componentDidMount() {
        let wrap_class = 'ind-galler-list sl-item ';

        if(this.props.galleryInfo.gal_type === 'AUDIO' || this.props.galleryInfo.gal_type === 'VIDEO') {
            wrap_class += ' player-static';
            this.setState({play : false});
        }
        this.setState({wrap_class : wrap_class});


    }

    render() {
        let item = this.props.detail;
        let itemIndex = this.props.galIndex;
        let imgpath = IMGIX_PATH +'assets/slider/'+ item.img_name+'?fit=crop&h=365&w=400&auto=enhance&dpr=3%203x';
        let defImgSrc ='';

      //  let wrap_class = 'ind-galler-list ';


        if(this.props.galleryInfo.gal_type === 'MY_UPLOADS') {
            defImgSrc = require("../../assets/images/no-gallery.jpg");
        }
        else if(this.props.galleryInfo.gal_type === 'AUDIO') {
            defImgSrc = require("../../assets/images/no-audio.jpg");
        }
        else if(this.props.galleryInfo.gal_type === 'VIDEO') {
            defImgSrc = require("../../assets/images/no-video.jpg");
        }
        else{
            defImgSrc = require("../../assets/images/no-gallery.jpg");
        }

        return (

            <div className={this.state.wrap_class} data-toggle="modal" data-target="#galleryModal" onClick={() => { this.props.galleryInfo.gal_type === 'AUDIO' ? this.playAudio(itemIndex): this.initiateSlider(itemIndex)  }} >
                <div className="gallery-thumb">
                    {this.props.galleryInfo.gal_type === 'AUDIO' &&
                    <button class="file-close" onClick={(e)=>this.closeAudio(e,itemIndex)}></button>
                    }
                    <ReactImageFallback
                        src={imgpath}
                        fallbackImage={defImgSrc}
                        initialImage={defImgSrc}
                        alt="cool image should be here"
                        className="my-image" />
                </div>

                { this.props.galleryInfo.gal_type === 'AUDIO' && <AudioItem item = {item} id={itemIndex}  /> }
            </div>

        );
    }


}

function mapStateToProps(state) {
    return {
        galleryInfo  :galleryReducers.setGalleryUpdate(state)
    };

}

export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId
})(GraphicItem));




// WEBPACK FOOTER //
// ./src/components/gallery/GraphicItem.js